import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Layout } from "../layout";
import { ROUTES } from "~/const/route";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Button, TextField, Grid } from "@material-ui/core";
import { useModule } from "./hooks/index";
import { RootState } from "~/redux/rootReducer";

export const SpecialistLogin: React.VFC = () => {
  // styles
  const classes = useStyles();

  // routing
  const history = useHistory();
  const navigateRegistor = () => history.push(ROUTES.SPECIALIST.REGISTOR);

  // hooks
  const {
    states: { email, password },
    setters: { changeEmail, changePassword },
    actions: { onClickLogin },
  } = useModule();

  // global state
  const authState = useSelector((state: RootState) => state.specialistAuth);

  // action
  const onKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") onClickLogin();
  };

  return (
    <Layout>
      <h1 className={classes.title}>SHUZO 専門家情報登録/編集サイト</h1>
      <p className={classes.text}>
        終活支援アプリ「SHUZO」に掲載する専門家のためのWebサイトです。
      </p>
      <p className={classes.text}>
        既に登録がお済みの方は、下記よりログインして登録情報を編集することができます。
      </p>
      <Card className={classes.card}>
        <CardContent>
          <p className={classes.loginLabel}>ログイン</p>
          <TextField
            className={classes.textField}
            label="Email"
            variant="filled"
            type="email"
            value={email}
            onChange={changeEmail}
            error={authState.error?.email != undefined}
            helperText={authState.error?.email}
            onKeyPress={onKeyPress}
          />
          <TextField
            className={classes.textField}
            label="Password"
            variant="filled"
            type="password"
            value={password}
            onChange={changePassword}
            error={authState.error?.password != undefined}
            helperText={authState.error?.password}
            onKeyPress={onKeyPress}
          />
          <Grid className={classes.row} container justify="flex-end">
            <Button
              className={classes.button}
              variant="contained"
              onClick={navigateRegistor}
            >
              新規登録
            </Button>
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={onClickLogin}
            >
              ログイン
            </Button>
          </Grid>
          {/* <Grid className={classes.row} container justify="flex-end">
            <Button>パスワードをお忘れの方はこちら</Button>
          </Grid> */}
        </CardContent>
      </Card>
    </Layout>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: 34,
    fontWeight: "normal",
    margin: 0,
    marginTop: 70,
    marginBottom: 20,
  },
  text: {
    fontSize: 20,
    margin: 0,
  },
  card: {
    minWidth: 275,
    maxWidth: 500,
    margin: "auto",
    marginTop: 50,
    marginBottom: 50,
  },
  row: {
    marginTop: 10,
  },
  button: {
    display: "block",
    width: 128,
    marginRight: 10,
    marginLeft: 10,
  },
  textField: {
    width: "100%",
    marginBottom: 20,
  },
  loginLabel: {
    fontSize: 20,
    textAlign: "left",
  },
});
